module.exports = __webpack_public_path__ + "img/kuaiyaxiaochengxu.252cdc81.png";